const es = {
  header: {
    exit: 'Salir', // Exit
    logout: 'Cerrar sesión', // Logout
    toggleLanguage: 'Cambiar idioma', // Toggle language
  },
  appSelect: {
    title: 'Seleccionar App', // Select App
    receiving: 'Recepción', // Receiving
    grading: 'Clasificación', // Grading
    callback: 'Callback', // Callback
  },
  login: {
    title: 'Sistema de Gestión VSR', // VSR Management System
    subtitle: 'Recibir y Clasificar Artículos', // Receive & Grade Items
    currentEnvironment: 'Entorno Actual:', // Current Environment:
    identifier: 'Correo o nombre de usuario', // Email or Username
    identifierPlaceholder: 'Ingrese su correo o nombre de usuario', // Enter your email or username
    checking: 'Verificando...', // Checking...
    signingInAs: 'Iniciando sesión como', // Signing in as
    notYou: '¿No es usted?', // Not you?
    password: 'Contraseña', // Password
    passwordPlaceholder: 'Ingrese su contraseña', // Enter your password
    forgotPassword: '¿Olvidó su contraseña?', // Forgot password?
    loggingIn: 'Iniciando sesión...', // Logging in...
    loginButton: 'Iniciar sesión', // Login
    selectStation: 'Seleccionar Estación', // Select Station
    selectStationPlaceholder: 'Seleccione una estación', // Select a station
    continuing: 'Continuando...', // Continuing...
    continueButton: 'Continuar', // Continue
    back: 'Atrás', // Back
    noStations: 'No hay estaciones disponibles para este usuario', // No stations available for this user
  },
  toast: {
    loginSuccess: 'Inicio de sesión exitoso', // Login successful
    pleaseEnterIdentifier: 'Por favor ingrese su correo o nombre de usuario', // Please enter your email or username
    noAccountFound: 'No se encontró una cuenta para ese correo o nombre de usuario', // No account found for that email or username
    accountDisabled: 'Esta cuenta ha sido deshabilitada. Contacte a un administrador.', // This account has been disabled. Contact an admin.
    signInFailed: 'Error al iniciar sesión', // Sign in failed
    pleaseEnterCredentials: 'Por favor ingrese correo y contraseña', // Please enter email and password
    loginFailed: 'Error al iniciar sesión', // Login failed
    pleaseSelectStation: 'Por favor seleccione una estación', // Please select a station
    pleaseEnterTracking: 'Por favor ingrese número de rastreo', // Please enter tracking number
    fedexDetected: '✓ ¡Rastreo FedEx detectado! Procesando...', // ✓ FedEx tracking detected! Processing...
    requestFailed: 'Solicitud fallida', // Request failed
    sessionExpired: 'Su sesión ha expirado. Por favor inicie sesión de nuevo.', // Your session has expired. Please log in again.
    pleaseEnterProduct: 'Por favor ingrese número de producto', // Please enter product number
    passwordUpdated: '¡Contraseña actualizada! Por favor inicie sesión con su nueva contraseña.', // Password updated! Please log in with your new password.
    failedChangePassword: 'Error al cambiar contraseña', // Failed to change password
    verificationCodeSent: 'Código de verificación enviado a su correo', // Verification code sent to your email
    failedSendCode: 'Error al enviar código de verificación', // Failed to send verification code
    passwordResetSuccess:
      '¡Contraseña restablecida! Por favor inicie sesión con su nueva contraseña.', // Password reset successful! Please log in with your new password.
    failedResetPassword: 'Error al restablecer contraseña', // Failed to reset password
    passwordChangedSuccess: '¡Contraseña cambiada exitosamente!', // Password changed successfully!
    networkError: 'Error de red. Por favor intente de nuevo.', // Network error. Please try again.
    problemReportedSuccess: 'Problema reportado exitosamente', // Problem reported successfully
    failedReportProblem: 'Error al reportar el problema', // Failed to report problem
    receiptClosedSuccess: 'Recibo cerrado exitosamente', // Receipt closed successfully
    failedCloseReceipt: 'Error al cerrar el recibo', // Failed to close receipt
    itemGradedSuccess: 'Artículo calificado exitosamente', // Item graded successfully
    failedGradeItem: 'Error al calificar el artículo', // Failed to grade item
    scanningFedexTracking: 'Escaneando número de rastreo FedEx...', // Scanning FedEx tracking number...
    scanningTracking: 'Escaneando número de rastreo...', // Scanning tracking number...
    fedexTrackingFound: '✓ ¡Rastreo FedEx encontrado! Cargando artículos...', // ✓ FedEx tracking found! Loading items...
    trackingFound: '✓ ¡Rastreo encontrado! Cargando artículos...', // ✓ Tracking found! Loading items...
    trackingNotFound: 'Número de rastreo no encontrado', // Tracking number not found
    failedConnectServer: '✗ Error al conectar con el servidor', // ✗ Failed to connect to server
    noValidSession: 'No se encontró una sesión válida', // No valid session found
  },
  receiving: {
    title: 'Escanear Caja de Envío', // Scan Shipping Box
    trackingLabel: 'Rastreo #', // Tracking #
    scanPlaceholder: 'Escanear rastreo...', // Scan tracking...
  },
  scanShippingBox: {
    title: 'Escanear Caja de Envío', // Scan Shipping Box
    trackingLabel: 'Rastreo #', // Tracking #
    inputPlaceholder: 'Campo de entrada', // Input field
    previousTracking: 'Rastreo Anterior #', // Previous Tracking #
    closeReceipt: 'CERRAR RECIBO', // CLOSE RECEIPT
  },
  scanItem: {
    title: 'Escanear Artículo', // Scan Item
    trackingLabel: 'Rastreo #', // Tracking #
    upcLabel: 'UPC', // UPC
    inputPlaceholder: 'Campo de entrada', // Input field
    cancel: 'Cancelar', // Cancel
    problem: 'Problema', // Problem
    problemFailed: 'Error al resolver el problema. Por favor intente de nuevo.', // Problem resolution failed. Please try again.
    problemResolved: 'Problema resuelto exitosamente.', // Problem resolved successfully.
  },
  confirmItem: {
    reporting: 'Reportando...', // Reporting...
    problem: 'Problema', // Problem
    callbackTitle: 'CALLBACK', // CALLBACK
    unexpectedItem: 'ARTÍCULO INESPERADO', // UNEXPECTED ITEM
  },
  gradeItem: {
    title: 'Calificar Artículo', // Grade Item
    unexpected: 'INESPERADO', // UNEXPECTED
    isNew: '¿Es Nuevo?', // Is New?
    yes: 'Sí', // Yes
    no: 'No', // No
    hasPackaging: '¿Tiene Empaque?', // Has Packaging?
    condition: '¿Condición?', // Condition?
    usable: 'Usable', // Usable
    unusable: 'No Usable', // Unusable
    reject: '¿Rechazar?', // Reject?
    rejectButton: 'Rechazar', // Reject
    submitting: 'Enviando...', // Submitting...
    submit: 'Enviar', // Submit
    trackingLabel: 'Rastreo:', // Tracking:
    articleLabel: 'Artículo #:', // Article #:
    descLabel: 'Desc:', // Desc:
    colorSizeLabel: 'Color/Talla:', // Color/Size:
    callbackBadge: 'CALLBACK', // CALLBACK
    productAlt: 'Producto', // Product
    na: 'N/D', // N/A
  },
  confirmClose: {
    trackingLabel: 'Rastreo:', // Tracking:
    summary: 'Resumen', // Summary
    expectedTotal: 'Total Esperado', // Expected Total
    actualScanned: 'Escaneado Real', // Actual Scanned
    expectedScanned: 'Escaneado Esperado', // Expected Scanned
    unexpected: 'Inesperado', // Unexpected
    fraudScanned: 'Fraude Escaneado', // Fraud Scanned
    warningTitle: 'ADVERTENCIA - ARTÍCULOS FALTANTES', // WARNING - MISSING ITEMS
    finishTitle: 'CONFIRMAR FINALIZACIÓN DE DEVOLUCIÓN', // CONFIRM RETURN FINISH
    warningMessage: 'El total escaneado real es menor al total esperado', // Actual scanned is less than expected total
    back: 'Atrás', // Back
    moveToProblemTeam: 'Mover al Equipo de Problemas', // Move to Problem Team
    processing: 'Procesando...', // Processing...
    finishReturn: 'Finalizar Devolución', // Finish Return
    moveToProblemSuccess: 'Recibo movido al equipo de problemas', // Receipt moved to problem team
    moveToProblemFailedDefault: 'Error al mover al equipo de problemas', // Failed to move to problem team
    networkError: 'Error de red. Por favor intente de nuevo.', // Network error. Please try again.
  },
  disposition: {
    title: 'Disposición', // Disposition
    trackingLabel: 'Rastreo #', // Tracking #
    articleLabel: 'Artículo #', // Article #
    descLabel: 'Desc:', // Desc:
    colorSizeLabel: 'Color/Talla:', // Color/Size:
    moveTo: 'MOVER A', // MOVE TO
    confirm: 'CONFIRMAR', // CONFIRM
    productAlt: 'Producto', // Product
    na: 'N/D', // N/A
  },
  gradingDisabled: {
    title: 'Clasificación DESHABILITADA', // Grading DISABLED
    message:
      'La Clasificación del Día Actual está Cerrada. Consulte a un gerente para abrir un nuevo día de procesamiento.', // The Current Day's Grading is Closed. Please See a manager about opening a new day for processing.
    close: 'CERRAR', // CLOSE
  },
  changePassword: {
    mustSetPassword: 'Debe establecer una nueva contraseña antes de continuar.', // You must set a new password before continuing.
    newPassword: 'Nueva Contraseña', // New Password
    newPasswordPlaceholder: 'Ingrese nueva contraseña', // Enter new password
    confirmPassword: 'Confirmar Contraseña', // Confirm Password
    confirmPasswordPlaceholder: 'Confirme nueva contraseña', // Confirm new password
    updating: 'Actualizando...', // Updating...
    setNewPassword: 'Establecer Nueva Contraseña', // Set New Password
    back: 'Atrás', // Back
  },
  forgotPassword: {
    description:
      'Ingrese su correo y le enviaremos un código de verificación para restablecer su contraseña.', // Enter your email address and we'll send you a verification code to reset your password.
    email: 'Correo electrónico', // Email
    emailPlaceholder: 'Ingrese su correo', // Enter your email
    sending: 'Enviando...', // Sending...
    sendCode: 'Enviar Código de Verificación', // Send Verification Code
    backToLogin: 'Volver al Inicio de Sesión', // Back to Login
    verificationCodeDescription:
      'Ingrese el código de verificación enviado a {{email}} y elija una nueva contraseña.', // Enter the verification code sent to {{email}} and choose a new password.
    verificationCode: 'Código de Verificación', // Verification Code
    verificationCodePlaceholder: 'Ingrese código de verificación', // Enter verification code
    newPassword: 'Nueva Contraseña', // New Password
    newPasswordPlaceholder: 'Ingrese nueva contraseña', // Enter new password
    confirmPassword: 'Confirmar Contraseña', // Confirm Password
    confirmPasswordPlaceholder: 'Confirme nueva contraseña', // Confirm new password
    resetting: 'Restableciendo...', // Resetting...
    resetPassword: 'Restablecer Contraseña', // Reset Password
    resendCode: 'Reenviar Código', // Resend Code
  },
  userProfile: {
    ariaLabel: 'Perfil de usuario', // User profile
    profileTitle: 'Perfil', // Profile
    roleLabel: 'Rol:', // Role:
    stationLabel: 'Estación:', // Station:
    signInLabel: 'Inicio de sesión:', // Sign-in:
    passwordless: 'Sin contraseña', // Passwordless
    password: 'Contraseña', // Password
    environmentLabel: 'Entorno:', // Environment:
    na: 'N/D', // N/A
    languageLabel: 'Idioma', // Language
    languageUpdated: 'Idioma actualizado', // Language updated
    failedToUpdateLanguage: 'Error al actualizar el idioma', // Failed to update language
    changePassword: 'Cambiar Contraseña', // Change Password
  },
  locale: {
    english: 'Inglés', // English
    spanish: 'Español', // Spanish
  },
  roles: {
    receiving: 'Llegada', // Arrival
    grading: 'Clasificación', // Grading
    rtv_pallet_build: 'Armado de Tarima', // Pallet Build
    admin: 'Administrador', // Admin
  },
  changePasswordForm: {
    currentPassword: 'Contraseña Actual', // Current Password
    currentPasswordPlaceholder: 'Ingrese contraseña actual', // Enter current password
    newPassword: 'Nueva Contraseña', // New Password
    newPasswordPlaceholder: 'Ingrese nueva contraseña', // Enter new password
    confirmNewPassword: 'Confirmar Nueva Contraseña', // Confirm New Password
    confirmPasswordPlaceholder: 'Confirme nueva contraseña', // Confirm new password
    updating: 'Actualizando...', // Updating...
    changePassword: 'Cambiar Contraseña', // Change Password
    back: 'Atrás', // Back
  },
  validation: {
    passwordsDoNotMatch: 'Las contraseñas no coinciden', // Passwords do not match
    currentPasswordRequired: 'La contraseña actual es obligatoria', // Current password is required
    verificationCodeRequired: 'El código de verificación es obligatorio', // Verification code is required
    invalidEmail: 'Ingrese un correo válido', // Enter a valid email
  },
  passwordCriteria: {
    minLength: 'Al menos 8 caracteres', // At least 8 characters
    uppercase: 'Una letra mayúscula', // One uppercase letter
    lowercase: 'Una letra minúscula', // One lowercase letter
    number: 'Un número', // One number
    special: 'Un carácter especial', // One special character
  },
  arrivalDisposition: {
    arrival: 'Llegada', // Arrival
    received: 'Recibido', // Received
    dismiss: 'Descartar', // Dismiss
    rma: 'RMA', // RMA
    expected: 'Esperado', // Expected
    status: 'Estado', // Status
  },
  gradingDispositionSheet: {
    moveTo: 'Mover A', // Move To
    dismiss: 'Descartar', // Dismiss
    article: 'Artículo', // Article
    upc: 'UPC', // UPC
    color: 'Color', // Color
    colorName: 'Nombre de Color', // Color Name
    size: 'Talla', // Size
  },
  app: {
    loading: 'Cargando...', // Loading...
  },
  palletBuildBackButton: {
    goBack: 'Volver', // Go Back
  },
  receiptClosed: {
    title: 'RECIBO CERRADO', // RECEIPT CLOSED
    subtitle: 'Todos los artículos clasificados!', // All items graded
    trackingPrefix: 'Rastreo #', // Tracking #
    returningIn: 'Volviendo a escanear rastreo en {{count}}…', // Back to tracking scan in {{count}}…
    continue: 'Continuar', // Continue
  },
  confirmCountdown: {
    headingIn: 'Enviando a clasificación en {{count}}…', // Heading to grading in {{count}}…
    cancel: 'Cancelar', // Cancel
    trackingLabel: 'Rastreo', // Tracking
    articleLabel: 'Artículo', // Article
    colorLabel: 'Color', // Color
    sizeLabel: 'Talla', // Size
    na: 'N/D', // N/A
    productAlt: 'Producto', // Product
    confirmed: 'CONFIRMADO', // CONFIRMED
  },
  problemScreen: {
    title: 'PROBLEMA', // PROBLEM
    defaultMessage: 'Mover al Equipo de Problemas', // Move to Problems Team
    trackingPrefix: 'Rastreo#', // Tracking#
    messages: {
      alreadyArrived: 'Paquete ya llegado {{rmaId}}', // Package already arrived: {{rmaId}}
      missingFromMaster: 'Productos faltantes del maestro', // Products missing from master
      multiplePackagesFound: 'Se encontraron múltiples paquetes', // Multiple packages found
      packageNotFound: 'Paquete no encontrado', // Package not found
    },
  },
  receivingCallback: {
    title: 'CALLBACK', // CALLBACK
    defaultMessage: 'No guardar - gestionar callback', // Do not put away - handle callback
    trackingPrefix: 'Rastreo#', // Tracking#
  },
  receivingGrading: {
    title: 'CLASIFICACIÓN', // GRADING
    trackingPrefix: 'Rastreo#', // Tracking#
  },
  modeSelect: {
    heading: 'Seleccionar Modo', // Select Mode
    subheading: 'Elija su tipo de operación para comenzar', // Choose your operation type to get started
    moveLabel: 'Mover', // Move
    moveDescription: 'Transferir inventario entre ubicaciones', // Transfer inventory between locations
    subItemPallet: 'tarima', // pallet
    palletBuildLabel: 'Construcción de Tarima', // Pallet Build
    palletBuildDescription: 'Crear cajas, asignar productos, construir y preparar tarimas', // Create cases, assign products, build & stage pallets
    subItemCreateCase: 'crear caja', // create case
    subItemBuildPallet: 'construir tarima', // build pallet
    subItemWeighClose: 'pesar y cerrar', // weigh & close
    sectionLabelPalletManagement: 'Gestión de Tarimas', // Pallet Management
  },
  moveConfirm: {
    eyebrow: 'Mover Tarima', // Move Pallet
    heading: 'Confirmar Movimiento', // Confirm Move
    transferDetails: 'Detalles de Transferencia', // Transfer Details
    palletLabel: 'Tarima', // Pallet
    destinationLabel: 'Destino', // Destination
    casesProducts: '{{cases}} cajas · {{products}} productos', // {{cases}} cases · {{products}} products
    confirm: 'Confirmar', // Confirm
    moving: 'Moviendo...', // Moving...
    cancel: 'Cancelar', // Cancel
    moveFailed: 'Error al mover la tarima. Por favor intente de nuevo.', // Failed to move pallet. Please try again.
  },
  moveDestination: {
    eyebrow: 'Mover Tarima', // Move Pallet
    errorTitle: 'La Ubicación No Existe', // Location Doesn't Exist
    title: 'Escanear Destino', // Scan Destination
    errorMessage: 'Por favor escanee la ubicación de destino nuevamente.', // Please scan the destination location again.
    palletLabel: 'Tarima', // Pallet
    destinationLabel: 'Destino', // Destination
    notScanned: 'No escaneado', // Not scanned
    palletInfo: 'Información de Tarima', // Pallet Info
    status: 'Estado', // Status
    cases: 'Cajas', // Cases
    products: 'Productos', // Products
    inputField: 'Campo de Entrada', // Input Field
    placeholder: 'Escanear ubicación de destino...', // Scan destination location...
    back: 'Atrás', // Back
  },
  moveScan: {
    eyebrow: 'Mover Tarima', // Move Pallet
    title: 'Escanear Tarima', // Scan Pallet
    palletLabel: 'Tarima', // Pallet
    notScannedYet: 'Aún no escaneado', // Not scanned yet
    inputField: 'Campo de Entrada', // Input Field
    placeholder: 'Escanear ID de tarima...', // Scan pallet ID...
    cancel: 'Cancelar', // Cancel
    scanFailed: 'Error al encontrar la tarima. Por favor intente de nuevo.', // Failed to find pallet. Please try again.
  },
  palletBuildMenu: {
    eyebrow: 'Construcción de Tarima', // Pallet Build
    heading: 'Seleccionar Paso', // Select Step
    subheading: 'Siga los pasos para construir y preparar una tarima', // Follow the steps to build and stage a pallet
    caseLabel: 'Caja:', // Case:
    palletLabel: 'Tarima:', // Pallet:
    manageCaseLabel: 'Gestionar Caja', // Manage Case
    manageCaseDescription: 'Crear cajas y asignar productos', // Create cases and assign products
    buildPalletLabel: 'Construir Tarima', // Build Pallet
    buildPalletDescription: 'Crear tarima y asignar cajas', // Create pallet and assign cases
    weighCloseLabel: 'Pesar y Cerrar', // Weigh & Close
    weighCloseDescription: 'Pesar tarima y cerrar a preparada', // Weigh pallet and close to staged
    backToMenu: 'Volver al menú', // Back to menu
  },
  caseScan: {
    eyebrow: 'Construcción de Tarima · Paso 1', // Pallet Build · Step 1
    title: 'Escanear Caja', // Scan Case
    createOrSelect: 'Crear o seleccionar una caja', // Create or select a case
    scanToBegin: 'Escanee un ID de caja para comenzar a asignar productos', // Scan a case ID to begin assigning products
    currentCaseInfo_one:
      'La caja actual tiene {{count}} producto - escanear una nueva caja cambiará el contexto.', // Current case has {{count}} product - scanning a new case will switch context.
    currentCaseInfo_other:
      'La caja actual tiene {{count}} productos - escanear una nueva caja cambiará el contexto.', // Current case has {{count}} products - scanning a new case will switch context.
    caseBarcode: 'Código de Caja', // Case Barcode
    placeholder: 'Escanear o escribir ID de caja...', // Scan or type case ID...
    back: 'Atrás', // Back
    scanning: 'Escaneando caja...', // Scanning case...
    caseIdInvalid: 'El ID de la caja debe tener 20 dígitos.', // Case ID must be 20 digits.
    scanFailed: 'Error al escanear la caja. Por favor intente de nuevo.', // Failed to scan case. Please try again.
    alreadyExists: 'La caja ya existe. Cargando productos...', // Case already exists. Loading products...
    newCase: 'Caja nueva - agregue productos para construirla', // New case - add products to build it
  },
  palletScan: {
    eyebrow: 'Construcción de Tarima · Paso 2', // Pallet Build · Step 2
    title: 'Escanear Tarima', // Scan Pallet
    createOrSelect: 'Crear o seleccionar una tarima', // Create or select a pallet
    scanToBegin: 'Escanee un ID de tarima para comenzar a asignar cajas', // Scan a pallet ID to begin assigning cases
    currentPalletInfo_one:
      'La tarima actual tiene {{count}} caja - escanear una nueva tarima cambiará el contexto.', // Current pallet has {{count}} case - scanning a new pallet will switch context.
    currentPalletInfo_other:
      'La tarima actual tiene {{count}} cajas - escanear una nueva tarima cambiará el contexto.', // Current pallet has {{count}} cases - scanning a new pallet will switch context.
    palletBarcode: 'Código de Tarima', // Pallet Barcode
    placeholder: 'Escanear o escribir ID de tarima...', // Scan or type pallet ID...
    back: 'Atrás', // Back
    scanning: 'Escaneando tarima...', // Scanning pallet...
    palletIdInvalid: 'El ID de la tarima debe tener 20 dígitos.', // Pallet ID must be 20 digits.
    scanFailed: 'Error al escanear la tarima. Por favor intente de nuevo.', // Failed to scan pallet. Please try again.
    scanned: 'Tarima escaneada', // Pallet scanned
    newPallet: 'Tarima nueva - agregue cajas para construirla', // New pallet - add cases to build it
  },
  assignCases: {
    eyebrow: 'Construcción de Tarima · Paso 2', // Pallet Build · Step 2
    title: 'Asignar Cajas', // Assign Cases
    caseNotFoundTitle: 'Caja no encontrada', // Case not found
    caseNotFoundDescription: 'Cree la caja primero y luego regrese.', // Create the case first, then come back.
    goToManageCase: 'Ir a Gestionar Caja', // Go to Manage Case
    caseIdInvalid: 'El ID de la caja debe tener 20 dígitos.', // Case ID must be 20 digits.
    clear: 'Limpiar', // Clear
    palletLabel: 'Tarima', // Pallet
    addLabel: 'Agregar', // Add
    removeLabel: 'Quitar', // Remove
    addCaseHeading: 'Agregar Caja', // Add Case
    removeCaseHeading: 'Quitar Caja', // Remove Case
    assignedCasesLabel: 'Cajas Asignadas', // Assigned Cases
    noCasesYet: 'Aún no hay cajas asignadas', // No cases assigned yet
    removingCase: 'Quitando caja...', // Removing case...
    addingCase: 'Agregando caja...', // Adding case...
    caseBarcodeLabel: 'Código de Caja', // Case Barcode
    placeholder: 'Escanear caja...', // Scan case...
    switchTo: 'Cambiar a {{mode}}', // Switch to {{mode}}
    doneButton: 'Listo', // Done
    caseRemovedFromPallet: 'Caja eliminada de la tarima', // Case removed from pallet
    caseAddedToPallet: 'Caja agregada a la tarima', // Case added to pallet
    palletClosedMessage: 'La tarima está cerrada - no se pueden agregar ni quitar cajas', // Pallet is closed - cases cannot be added or removed
    actionFailed: 'Error al {{action}} la caja. Por favor intente de nuevo.', // Failed to {{action}} case. Please try again.
    addAction: 'agregar', // add
    removeAction: 'quitar', // remove
  },
  assignProducts: {
    eyebrow: 'Construcción de Tarima · Paso 1', // Pallet Build · Step 1
    title: 'Asignar Productos', // Assign Products
    caseLabel: 'Caja', // Case
    upcInvalid: 'El UPC del producto debe tener 12 dígitos.', // Product UPC must be 12 digits.
    cartonClosedMessage: 'La caja está cerrada - no se pueden agregar ni quitar productos', // Carton is closed - products cannot be added or removed
    clear: 'Limpiar', // Clear
    addLabel: 'Agregar', // Add
    removeLabel: 'Quitar', // Remove
    addProductHeading: 'Agregar Producto', // Add Product
    removeProductHeading: 'Quitar Producto', // Remove Product
    productHeader: 'Producto', // Product
    qtyHeader: 'Cant.', // Qty
    noProductsYet: 'Aún no hay productos agregados', // No products added yet
    removingProduct: 'Quitando producto...', // Removing product...
    addingProduct: 'Agregando producto...', // Adding product...
    productBarcodeLabel: 'Código de Producto', // Product Barcode
    placeholder: 'Escanear producto...', // Scan product...
    switchTo: 'Cambiar a {{mode}}', // Switch to {{mode}}
    done: 'Listo', // Done
    productRemoved: 'Producto eliminado', // Product removed
    productAdded: 'Producto agregado', // Product added
    actionFailed: 'Error al {{action}} el producto. Por favor intente de nuevo.', // Failed to {{action}} product. Please try again.
    addAction: 'agregar', // add
    removeAction: 'quitar', // remove
  },
  weighClose: {
    eyebrow: 'Construcción de Tarima · Paso 3', // Pallet Build · Step 3
    title: 'Pesar y Cerrar', // Weigh & Close
    closePalletToStaged: 'Cerrar tarima a preparada', // Close pallet to staged
    recordWeight: 'Registre el peso y cierre la tarima', // Record weight and close the pallet
    palletBarcodeLabel: 'Código de Tarima', // Pallet Barcode
    palletPlaceholder: 'Escanear ID de tarima...', // Scan pallet ID...
    palletIdInvalid: 'El ID de la tarima debe tener 20 dígitos.', // Pallet ID must be 20 digits.
    clear: 'Limpiar', // Clear
    change: 'Cambiar', // Change
    palletLabel: 'Tarima', // Pallet
    weightLabel: 'Peso', // Weight
    kg: '(kg)', // (kg)
    weightPlaceholder: 'Ingrese el peso...', // Enter weight...
    locationLabel: 'Ubicación', // Location
    locationPlaceholder: 'Escanear ubicación...', // Scan location...
    closePalletButton: 'Cerrar Tarima', // Close Pallet
    back: 'Atrás', // Back
    scanPalletFailed: 'Error al escanear la tarima. Por favor intente de nuevo.', // Failed to scan pallet. Please try again.
    enterValidWeight: 'Ingrese un peso válido.', // Enter a valid weight.
    scanPalletFirst: 'Escanee una tarima primero.', // Scan a pallet first.
    locationDoesNotExist: 'La ubicación no existe. Por favor escanee de nuevo.', // Location doesn't exist. Please scan again.
    closingPallet: 'Cerrando tarima...', // Closing pallet...
    closePalletFailed: 'Error al cerrar la tarima. Por favor intente de nuevo.', // Failed to close pallet. Please try again.
    palletClosedMessage: 'La tarima está cerrada - el peso no se puede cambiar', // Pallet is closed - weight cannot be changed
  },
  palletBuild: {
    messages: {
      licenseAssignedToCase: 'Este ID ya está asignado a una caja.', // This ID is already assigned to a case.
      licenseAssignedToPallet: 'Este ID ya está asignado a una tarima.', // This ID is already assigned to a pallet.
      licenseAssignedToLocation: 'Este ID ya está asignado a una ubicación.', // This ID is already assigned to a location.
      caseCannotBeChanged: 'Esta caja no se puede modificar.', // This case cannot be changed.
      palletCannotBeChanged: 'Esta tarima no se puede modificar.', // This pallet cannot be changed.
      productNotEligibleForCallback: 'Este producto no es elegible para callback.', // This product is not eligible for callback.
      productNotFoundInCase: 'Producto no encontrado en esta caja.', // Product not found in this case.
      palletDoesNotExist: 'La tarima no existe.', // Pallet does not exist.
      failedToAssignCaseToPallet: 'Error al asignar la caja a la tarima.', // Failed to assign the case to the pallet.
      caseNotFoundInPallet: 'Caja no encontrada en esta tarima.', // Case not found on this pallet.
      failedToRemoveCaseFromPallet: 'Error al quitar la caja de la tarima.', // Failed to remove the case from the pallet.
      palletNotFound: 'Tarima no encontrada.', // Pallet not found.
      locationDoesNotExist: 'La ubicación no existe. Por favor escanee de nuevo.', // Location doesn't exist. Please scan again.
      locationNotAvailable: 'Esta ubicación no está disponible.', // This location is not available.
      failedToAssignPalletToLocation: 'Error al asignar la tarima a esta ubicación.', // Failed to assign the pallet to this location.
      internalServerError: 'Error interno del servidor. Por favor intente de nuevo.', // Internal server error. Please try again.
    },
  },
};

export default es;
